var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";

import { Icon } from "../../UI";
import { unselectAllDocuments } from "../../Library/actions/libraryActions";
import { uploadDocument, createDocument } from "../actions/uploadsActions";
import { wrapDispatch } from "../../Multireducer";

const extractTitle = (file) => {
  const title = file.name.
  replace(/\.[^/.]+$/, '').
  replace(/_/g, ' ').
  replace(/-/g, ' ').
  replace(/ {2}/g, ' ');

  return title.charAt(0).toUpperCase() + title.slice(1);
};

class UploadBox extends Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(files) {
    files.forEach((file) => {
      const doc = { title: extractTitle(file) };
      this.props.createDocument(doc).then((newDoc) => {
        this.props.uploadDocument(newDoc.sharedId, file);
      });
    });
    this.props.unselectAllDocuments();
  }

  render() {
    return /*#__PURE__*/(
      _jsx(Dropzone, {
        className: "upload-box force-ltr",
        style: {},
        onDrop: this.onDrop,
        accept: {
          'application/pdf': ['.pdf']
        } }, void 0,

      ({ getRootProps }) => /*#__PURE__*/
      // eslint-disable-next-line react/jsx-props-no-spreading
      React.createElement("div", getRootProps(), /*#__PURE__*/
      _jsx("div", { className: "upload-box_wrapper" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "upload" }), /*#__PURE__*/
      _jsx("button", { type: "button", className: "upload-box_link" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Browse your PDFs to upload")), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "or drop your files here.")), /*#__PURE__*/

      _jsx("div", { className: "protip" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "lightbulb" }), /*#__PURE__*/
      _jsx("b", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "ProTip!")), /*#__PURE__*/

      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "For better performance, upload your files in batches of 50 or less."))))));








  }
}







export function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    uploadDocument,
    unselectAllDocuments,
    createDocument
  },
  wrapDispatch(dispatch, 'uploads'));

}

export { UploadBox };
export default connect(mapStateToProps, mapDispatchToProps)(UploadBox);